import { getValueByType } from "./getValueByType";

export default getValueByType;
